import {
    SET_LOADING,
    SEARCH_INPUT,
    SET_PAGE,
    SET_MINI_LOADING,
    GET_SINGLE_SALES_ORDER,
    GET_SALES_ORDERS,
    SALES_ORDER_INPUT_CHANGE,
    GET_SI_CUSTOMERS,
    GET_SI_PRODUCTS,
    GET_SI_TERMS_CONDITIONS,
    CLEAR_SALES_ORDER,
    HANDLE_SI_SELECT_TERMS_CONDITIONS,
    HANDLE_SI_SELECT_ITEM,
    HANDLE_SI_REMOVE_ITEM,
    HANDLE_SI_ADD_ITEM,
    HANDLE_SI_SRP,
    HANDLE_SI_QTY,
    HANDLE_SI_INPUT_ATTR,
    HANDLE_SI_TOGGLE_EDIT_BTN_ATTR,
    HANDLE_SI_SELECT_CUSTOMER,
    HANDLE_SI_CHECK_VAT,
    GET_SI_TEMPLATES,
    HANDLE_SELECT_SI_TEMPLATE,
    HANDLE_SI_SELECT_TYPE_RECEIPT,
    HANDLE_SI_TOGGLE_EDIT_ROW,
    HANDLE_SI_EDIT_INPUT_ROW,
    HANDLE_SI_EDIT_UPDATE_ROW,
    HANDLE_SI_SUBMIT_ATTR,
    HANDLE_SI_SELECT_PAYMENT,
    HANDLE_SI_SELECT_PAYMENT_TYPE,
    SET_SI_ITEM_ID,
    SET_MODAL,
    HANDLE_CHECK_MANUAL,
    SO_GET_QUOTATIONS,
    HANDLE_SO_SELECT_QUOTATION,
    SET_DATE_PICKER,
    SORT_BY_COLUMN,
    SET_QU_ITEM_ID,
    GET_ROWS_TO_DELETE,
    SET_ROW_CHECKED,
    ITEMS_TEMPLATE,
    ADD_ITEM,
    TOGGLE_DISCOUNT_ROW,
    SET_LAST_ADDED_DROPDOWN_INDEX,
    SI_SET_CUSTOMER_DATA,
    SO_CLEAR_UPLOAD,
    SI_SELECT_TAX_TYPE,
    SI_COMPUTATION_HANDLER,
    SEND_EMAIL,
    DYNAMIC_SEND_EMAIL,
    RESEND_EMAIL,
    DOWNLOAD_BTN,
    EMAIL_SETTING_DATA,
    BTN_FORM,
    GET_STATUS,
    GET_SO_STATUS,
    CREATE_PRODUCT,
    HANDLE_ITEM_FORM_DISABLE,
    GET_SO_PRODUCT_LOT,
    SO_PRODUCT_LOT_INPUT_CHANGE,
    SET_SO_ITEM_ID,
} from './../../types';
import {
    ToastSuccess,
    ToastDanger,
    ToastWarning,
} from '../../../Services/_toast.service';
import $ from 'jquery';
import { SalesOrderService } from './_service.salesorder';
import { ProductService } from '../product/_service.product';
import {
    SwalWarning,
    SwalError,
    SwalSuccessAutoRemove,
    SwallverfiyPass,
    SwalWarningHtml,
    SwalUpdatePayment,
    SwalVerifyUpdatePayment,
} from '../../../Services/_swal.service';
import { QuotationService } from '../quotation/_service.quotation';
import { loadUnReceived } from '../receiving/receiving.actions';
import { blockRoute, setMUIPage } from '../helper/helper.actions';
import { getNumRows, getSubSetting, getUserData } from '../../../Utils/Common';
import { getSettingApp } from '../settings_app/setting_app.actions';
import { viewDr, delClearUpload } from '../delivery/delivery.actions';

// DISCOUNT
export const handleSelectDiscountType = (selectOption) => async (dispatch) => {
    // console.log(selectOption)
    // dispatch({ type: SALES_ORDER_INPUT_CHANGE, payload: { key: 'discount', value: 0 }})
    // dispatch({ type: SALES_ORDER_INPUT_CHANGE, payload: { key: 'discount_type', value: selectOption.value } });

    // ** Updated select
    dispatch({
        type: SALES_ORDER_INPUT_CHANGE,
        payload: { key: 'discount', value: 0 },
    });
    dispatch({
        type: SALES_ORDER_INPUT_CHANGE,
        payload: { key: 'discount_type', value: selectOption },
    });
};

export const handleInputChangeDiscount = (e) => async (dispatch, getState) => {
    const rawValue = e.target.value;

    if (rawValue !== '') {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { single_sales_order } = getState().sales_order;

    // Allow empty string for typing UX
    if (rawValue === '') {
        dispatch({
            type: SALES_ORDER_INPUT_CHANGE,
            payload: { key: e.target.name, value: '' },
        });
        return;
    }

    // Parse and remove leading zeros
    const parsed = parseFloat(rawValue);
    const value = isNaN(parsed) ? '' : parsed;

    if (single_sales_order.discount_type.value === 'percent') {
        if (value > 100) {
            ToastDanger(
                'If your discount is percentage, discount should not be over 100'
            );
            dispatch({
                type: SALES_ORDER_INPUT_CHANGE,
                payload: { key: e.target.name, value: 100 },
            });
        } else if (value < 0) {
            ToastDanger('Discount should not be less than zero');
            dispatch({
                type: SALES_ORDER_INPUT_CHANGE,
                payload: { key: e.target.name, value: 0 },
            });
        } else {
            dispatch({
                type: SALES_ORDER_INPUT_CHANGE,
                payload: { key: e.target.name, value: value },
            });
        }
    } else {
        if (value < 0) {
            ToastDanger('Discount should not be less than zero');
            dispatch({
                type: SALES_ORDER_INPUT_CHANGE,
                payload: { key: e.target.name, value: 0 },
            });
        } else {
            dispatch({
                type: SALES_ORDER_INPUT_CHANGE,
                payload: { key: e.target.name, value: value },
            });
        }
    }
};

// Unified blur handler - normalize empty values to 0
// type: 'discount' | 'attr' | 'qty' | 'dynamicQty'
// index: only required for 'dynamicQty'
// attrName: only required for 'attr' (e.g., 'other')
export const handleBlurInput =
    (type, index = null, attrName = null) =>
    async (dispatch, getState) => {
        const { single_sales_order, itemSelected, edit_attr } =
            getState().sales_order;

        const isEmpty = (val) => val === '' || val === null || val === undefined;

        switch (type) {
            case 'discount':
                if (isEmpty(single_sales_order.discount)) {
                    dispatch({
                        type: SALES_ORDER_INPUT_CHANGE,
                        payload: { key: 'discount', value: 0 },
                    });
                }
                break;

            case 'attr':
                if (attrName && isEmpty(edit_attr[attrName])) {
                    dispatch({
                        type: HANDLE_SI_INPUT_ATTR,
                        payload: { key: attrName, value: 0 },
                    });
                }
                break;

            case 'qty':
                if (isEmpty(itemSelected.qty)) {
                    let multipliedPrice = 0 * itemSelected.srp;
                    dispatch({
                        type: HANDLE_SI_QTY,
                        payload: { qty: 0, amount: parseFloat(multipliedPrice) },
                    });
                }
                break;

            case 'dynamicQty':
                if (index !== null) {
                    let items = { ...single_sales_order.sales_order_items[index] };
                    if (isEmpty(items.qty)) {
                        items.qty = 0;
                        // Recalculate amount with 0 qty
                        if (items.srp !== items.unit_price) {
                            items.amount = 0 * parseFloat(items.unit_price);
                        } else {
                            items.amount = 0 * parseFloat(items.srp);
                        }
                        if (items.discount_type && items.discount_type.value !== 'none') {
                            items.discount_amount = 0;
                        }
                        const newItems1 = [...single_sales_order.sales_order_items];
                        newItems1[index] = items;
                        dispatch({ type: ADD_ITEM, payload: newItems1 });
                    } else if (typeof items.qty === 'string') {
                        items.qty = parseFloat(items.qty) || 0;
                        if (items.srp !== items.unit_price) {
                            items.amount = items.qty * parseFloat(items.unit_price);
                        } else {
                            items.amount = items.qty * parseFloat(items.srp);
                        }
                        if (items.discount_type && items.discount_type.value !== 'none') {
                            let discountAmount = 0;
                            if (items.discount_type.value === 'percent') {
                                discountAmount = (items.discount / 100) * items.amount;
                            } else if (items.discount_type.value === 'amount') {
                                discountAmount = items.discount;
                            }
                            items.amount = items.amount - discountAmount;
                            items.discount_amount = discountAmount || 0;
                        }
                        const newItems2 = [...single_sales_order.sales_order_items];
                        newItems2[index] = items;
                        dispatch({ type: ADD_ITEM, payload: newItems2 });
                    }
                }
                break;

            default:
                break;
        }
    };

export const handleDiscountItem =
    (index, remove = false) =>
    async (dispatch, getState) => {
        let { single_sales_order } = getState().sales_order;
        let items = { ...single_sales_order.sales_order_items[index] };

        if (!items.product_name) {
            ToastDanger('Please add Product item at least one.');
            return;
        }

        if (remove) {
            items['discount'] = 0;
            items['discount_type'] = { value: 'none', label: 'None' };
            items['discount_amount'] = 0;
            items['amount'] = items.srp * items.qty;
        }

        single_sales_order.sales_order_items[index] = items;

        dispatch({
            type: ADD_ITEM,
            payload: single_sales_order.sales_order_items,
        });

        dispatch({
            type: TOGGLE_DISCOUNT_ROW,
            payload: { index, remove },
        });
    };

export const handleInputDiscountProduct =
    (e, index) => async (dispatch, getState) => {
        let { name, value } = e.target;
        value = parseFloat(value);
        let { single_sales_order } = getState().sales_order;
        let items = { ...single_sales_order.sales_order_items[index] };

        // // Save original amount if not already saved
        // if (!items.hasOwnProperty('original_amount')) {
        //   items['original_amount'] = items.srp;
        // }

        let discountedAmount = 0;
        let discountAmount = 0;

        items.amount = items.srp * items.qty;

        if (value === '0') {
        } else if (items.discount_type.value === 'percent') {
            discountAmount = (value / 100) * items.amount;
            discountedAmount = items.amount - discountAmount;
            items.amount = discountedAmount;
        } else if (items.discount_type.value === 'amount') {
            discountAmount = value;
            discountedAmount = items.amount - value;
            items.amount = discountedAmount;
        }

        items[name] = parseFloat(value);
        items['discount_amount'] = discountAmount ? discountAmount : 0;

        single_sales_order.sales_order_items[index] = items;
        dispatch({
            type: ADD_ITEM,
            payload: single_sales_order.sales_order_items,
        });
    };

export const handleSelectDiscountTypeProduct =
    (selectOption, index) => async (dispatch, getState) => {
        let { single_sales_order } = getState().sales_order;
        let items = { ...single_sales_order.sales_order_items[index] };

        // Reset discount amount when changing discount type to 'amount'
        if (selectOption.value === 'amount' || 'percent' || 'none') {
            items.discount_amount = 0;
            items.amount = items.srp * items.qty;
        }

        items.discount_type = selectOption;
        items.discount = 0;

        single_sales_order.sales_order_items[index] = items;
        dispatch({
            type: ADD_ITEM,
            payload: single_sales_order.sales_order_items,
        });
    };

export const handleChangeStatusView =
    (status_view) => async (dispatch, getState) => {
        dispatch({ type: GET_STATUS, payload: status_view });

        let { search, sales_orders } = getState().sales_order;

        if (
            typeof sales_orders[status_view] === 'undefined' ||
            sales_orders[status_view] == null
        ) {
            dispatch({ type: SEARCH_INPUT, payload: '' });
            dispatch(getSalesOrders(1));
        } else {
            dispatch({
                type: SEARCH_INPUT,
                payload: sales_orders[status_view].search,
            });
            dispatch({
                type: GET_SALES_ORDERS,
                payload: {
                    sales_orders: sales_orders,
                    pagination: sales_orders[status_view],
                },
            });
        }
    };

// handle inputs
export const handleInputChange = (e) => async (dispatch) => {
    if (e.target.value !== '') {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    dispatch({
        type: SALES_ORDER_INPUT_CHANGE,
        payload: { key: e.target.name, value: e.target.value },
    });
};

// handle edit inputs
// export const handleSearchInput = e => async dispatch => dispatch({ type: SEARCH_INPUT, payload: e.target.value })
export const handleSearchInput = (e) => async (dispatch) => {
    dispatch({ type: SEARCH_INPUT, payload: e.target.value });
    // dispatch(getSalesOrders(1));
};

// loading
export const setLoading = (status) => async (dispatch) =>
    dispatch({ type: SET_LOADING, payload: status });
export const setMiniLoading = (status) => async (dispatch) =>
    dispatch({ type: SET_MINI_LOADING, payload: status });

// clear data
export const clearSalesOrder = () => async (dispatch) =>
    dispatch({ type: CLEAR_SALES_ORDER });

// set modal
export const setPage =
    (page, id, status = true) =>
    async (dispatch, getState) => {
        let { edit_url } = getState().sales_order;

        switch (page) {
            case 'main_page':
                dispatch({ type: SET_PAGE, payload: { page, status } });
                dispatch(clearSalesOrder());
                break;
            case 'edit_page':
                let edit_url_with_id = `${edit_url}/${id}`;
                dispatch({
                    type: SET_PAGE,
                    payload: { page, status, edit_url: edit_url_with_id },
                });
                break;
            case 'delete_modal':
                dispatch(getSingleSalesOrder(id, 'delete'));
                break;
            case 'print_modal_si':
                if (status) {
                    dispatch(getSingleSalesOrder(id));
                } else {
                    dispatch(soClearUpload());
                }
                dispatch({ type: SET_PAGE, payload: { page, status } });
                break;
            case 'print_modal_dr':
                if (status) {
                    dispatch(viewDr(id));
                } else {
                    dispatch(delClearUpload());
                }
                dispatch({ type: SET_PAGE, payload: { page, status } });
                break;
            default:
                // print_modal
                dispatch({ type: SET_PAGE, payload: { page, status } });
        }
    };

export const soClearUpload = () => async (dispatch) =>
    dispatch({ type: SO_CLEAR_UPLOAD });

// create selectOptions use in suppliers
const createSelectOption = (lists) => {
    let selectOptions = [];

    lists.map((val, i) => {
        let select = { value: val._id, label: val.name, i: i };

        selectOptions[i] = select;
    });

    return selectOptions;
};

export const handleSelectCustomer =
    (selectOption, preserveItems = false) => async (dispatch, getState) => {
        SalesOrderService.getSingleCustomer(selectOption.value)
            .then((res) => {
                const customerData = res.data.customer;
                let default_customer_value = {
                    value: customerData._id,
                    label: customerData.name,
                    data: customerData,
                };

                if (customerData.payment_terms) {
                    dispatch({
                        type: HANDLE_SI_SELECT_TERMS_CONDITIONS,
                        payload: customerData.payment_terms,
                    });
                } else {
                    const payment_terms = {
                        value: 'none',
                        label: 'None',
                    };
                    dispatch({
                        type: HANDLE_SI_SELECT_TERMS_CONDITIONS,
                        payload: payment_terms,
                    });
                }

                dispatch({
                    type: HANDLE_SI_SELECT_CUSTOMER,
                    payload: {
                        customer_id: selectOption.value,
                        customer: customerData,
                        default_customer_value: default_customer_value,
                    },
                });
                if (!preserveItems) {
                    let { item_template } = getState().sales_order;
                    let items_data = [item_template];
                    dispatch({ type: ADD_ITEM, payload: items_data });
                }
            })
            .catch((error) => {
                ToastDanger('Network error, please reload the page.');
                console.log(error);
            });
    };

// handle select payment terms
export const handleSelectTermsConditions =
    (selectOption) => async (dispatch) => {
        if (selectOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        dispatch({
            type: HANDLE_SI_SELECT_TERMS_CONDITIONS,
            payload: selectOption,
        });

        // If the payment terms is 'none', set receipt type to 'charged sales invoice'
        let receiptType;

        if (selectOption?.value === 'none') {
            receiptType = { value: 'none', label: 'None' };
        } else {
            receiptType = {
                value: 'charged sales invoice',
                label: 'Charged Sales Invoice',
            };
        }

        dispatch(handleSelectReceiptType(receiptType));
    };

// handle selec payment type
export const handleSelectPaymentType = (selectOption) => async (dispatch) => {
    if (selectOption) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    dispatch({
        type: HANDLE_SI_SELECT_PAYMENT_TYPE,
        payload: selectOption,
    });
};

// // handle select payment
// export const handleSelectPayment = selectOption => async dispatch => {
//     dispatch({ type: HANDLE_SI_SELECT_PAYMENT,payload: selectOption });
// }

// handle Select Item
export const handleSelectItem =
    (selectOption, index) => async (dispatch, getState) => {
        if (selectOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        let { single_sales_order } = getState().sales_order;
        let items = { ...single_sales_order.sales_order_items[index] };

        // Check if the product is already selected in other rows
        const isProductAlreadySelected =
            single_sales_order.sales_order_items.some(
                (item, i) => i !== index && item.product_id === selectOption._id
            );
        // if (isProductAlreadySelected) {
        //     // Display an error message (You can replace this with your preferred way of showing errors)
        //     ToastDanger('Product is already added on the list');
        //     // Remove the row
        //     dispatch(handleRemoveItem(index));
        // } else
        if (selectOption.instock === false) {
            ToastWarning('Product is out of stock');
            // Remove the row
            dispatch(handleRemoveItem(index));
        } else {
            items['_id'] = selectOption._id;
            items['product_id'] = selectOption._id;
            items['sku'] = selectOption.sku;
            items['product_name'] = selectOption.product_name;
            items['qty'] = parseInt(selectOption.qty);
            items['product_unit_id'] = selectOption.product_unit_id;
            items['product_unit_name'] = selectOption.product_unit_name;
            items['attribute_string'] = selectOption.attribute_string;
            const conversion = parseFloat(selectOption.conversion_to_base) || 1;
            items['srp'] = parseFloat(selectOption.srp);
            items['amount'] = parseFloat(selectOption.srp) * conversion * parseInt(selectOption.qty);
            items['status_code'] = selectOption.status_code;
            items['barcode'] = selectOption.barcode;
            items['description'] = selectOption.description;
            items['selected'] = true;
            items['brand'] = selectOption.brand;
            items['brand_id'] = selectOption.brand_id;
            items['category_id'] = selectOption.category_id;
            items['category'] = selectOption.category;
            items['discount_type'] = { label: 'None', value: 'none' }; // default discount type
            items['discount'] = 0; // default discount
            items['discount_amount'] = 0;
            items['non_iventory'] = selectOption.non_iventory;
            items['unit_price'] = parseFloat(selectOption.srp) * conversion;
            items['unit_srp'] = parseFloat(selectOption.srp) * conversion;
            items['product_units'] = selectOption.product_units;
            items['conversion_to_base'] = conversion;
            items['unit_barcode'] = selectOption.unit_barcode || selectOption.barcode;
            items['selected_lot_no'] = [];

            single_sales_order.sales_order_items[index] = items;
            dispatch({
                type: ADD_ITEM,
                payload: single_sales_order.sales_order_items,
            });
        }
    };

export const ShowComboBox = (index) => async (dispatch, getState) => {
    let { single_sales_order } = getState().sales_order;
    let items = { ...single_sales_order.sales_order_items[index] };
    items['selected'] = false;
    single_sales_order.sales_order_items[index] = items;
    dispatch({
        type: ADD_ITEM,
        payload: single_sales_order.sales_order_items,
    });
};

// handle Add Item
export const handleAddItem = (e) => async (dispatch, getState) => {
    e.preventDefault();

    if (e) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { itemSelected, single_sales_order } = getState().sales_order;

    const params = {
        _id: itemSelected._id,
        qty: itemSelected.qty,
        product_name: itemSelected.product_name,
    };

    const checkInStock = await dispatch(checkInStockQty(params));

    const duplicate = single_sales_order.sales_order_items.filter(
        (item) => item._id == itemSelected._id
    );

    if (checkInStock['error']) {
        ToastDanger(checkInStock['error']);
    } else if (itemSelected.qty == 0 || isNaN(itemSelected.qty)) {
        ToastDanger('Quantity field is required and cannot be a string value');
    } else if (itemSelected.srp == 0 || isNaN(itemSelected.srp)) {
        ToastDanger('Srp is required and cannot be a string value');
    } else if (itemSelected.product_name == '') {
        ToastDanger('Product Item is required, please select at least one');
    } else if (duplicate.length > 0) {
        ToastDanger(`${duplicate[0].product_name} is already on the list.`);
    } else {
        let sales_order_items =
            single_sales_order.sales_order_items.concat(itemSelected);

        dispatch({
            type: HANDLE_SI_ADD_ITEM,
            payload: { sales_order_items: sales_order_items },
        });
    }
};

// Check In Stock Qty of Product
export const checkInStockQty = (params) => async (dispatch, getState) => {
    let data = [];

    try {
        const checkInstock = await SalesOrderService.CheckInStock(params);
        data['status'] = checkInstock.data.status;
        data['error'] = checkInstock.data.error;
    } catch (e) {
        data['status'] = 0;
        data['error'] = e.error;
    }

    return data;
};

// Handle Remove Item
export const handleRemoveItem = (index) => async (dispatch, getState) => {
    if (index) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { sales_order_items } = getState().sales_order.single_sales_order;
    // removing value in array base on index
    let _sales_order_items = sales_order_items.filter((_, i) => i !== index);

    dispatch({
        type: HANDLE_SI_REMOVE_ITEM,
        payload: { sales_order_items: _sales_order_items },
    });
};

// handle Srp
export const handleInputSrp = (e) => async (dispatch, getState) => {
    e.preventDefault();

    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { itemSelected } = getState().sales_order;

    let srp = parseFloat(e.target.value);
    let amount = itemSelected.qty * srp;

    dispatch({ type: HANDLE_SI_SRP, payload: { srp: srp, amount: amount } });
};

// handle Qty
export const handleInputQty = (e) => async (dispatch, getState) => {
    e.preventDefault();

    const rawValue = e.target.value;

    if (rawValue) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    // Allow empty string for typing UX, otherwise parse and remove leading zeros
    let qty = rawValue;
    if (rawValue !== '') {
        // Remove leading zeros and non-numeric characters, ensure non-negative
        const parsed = parseInt(rawValue, 10);
        qty = isNaN(parsed) ? '' : Math.max(0, parsed);
    }

    let { itemSelected } = getState().sales_order;
    // Use 0 for calculation if empty, to keep amount accurate
    const qtyForCalc = qty === '' ? 0 : qty;
    let multipliedPrice = qtyForCalc * itemSelected.srp;

    dispatch({
        type: HANDLE_SI_QTY,
        payload: { qty: qty, amount: parseFloat(multipliedPrice) },
    });
};

// handle discount, other
export const handleInputAttr = (e) => async (dispatch) => {
    const rawValue = e.target.value;

    if (rawValue) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let name = e.target.name;

    // Allow empty string for typing UX
    if (rawValue === '') {
        dispatch({
            type: HANDLE_SI_INPUT_ATTR,
            payload: { key: name, value: '' },
        });
        return;
    }

    if (name == 'other') {
        // Parse and remove leading zeros for delivery fee
        const parsed = parseFloat(rawValue);
        const value = isNaN(parsed) ? '' : Math.max(0, parsed);
        dispatch({
            type: HANDLE_SI_INPUT_ATTR,
            payload: { key: name, value: value },
        });
    } else {
        const parsed = parseInt(rawValue, 10);
        const value = isNaN(parsed) ? '' : Math.max(0, parsed);
        dispatch({
            type: HANDLE_SI_INPUT_ATTR,
            payload: { key: name, value: value },
        });
    }
};

// handle toggle edit discount, other
export const toggleEditBtn = (status, attr) => async (dispatch, getState) => {
    // true || false, isDiscount, isOther
    dispatch({
        type: HANDLE_SI_TOGGLE_EDIT_BTN_ATTR,
        payload: { attr: attr, status: status },
    });
};

// handle discount, other, submit
export const handleAttrSubmit = (attr) => async (dispatch, getState) => {
    let { edit_attr } = getState().sales_order;
    let attr_val = edit_attr[attr];

    if (isNaN(attr_val)) {
        ToastDanger('Field required at least 0 value');
    } else {
        dispatch({
            type: HANDLE_SI_SUBMIT_ATTR,
            payload: { key: attr, value: attr_val },
        });
    }
};

// handle vat
export const handleCheckVat = (e) => async (dispatch) => {
    if (e.target.checked) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let checked;

    if (e.target.checked) {
        checked = 12;
    } else {
        checked = 0;
    }

    dispatch({ type: HANDLE_SI_CHECK_VAT, payload: checked });
};

// handle edit row
export const handleToggleEditRow = (index) => async (dispatch) => {
    dispatch({ type: HANDLE_SI_TOGGLE_EDIT_ROW, payload: index });
};

// handle input edit row
export const handleEditInputRow = (index, e) => async (dispatch, getState) => {
    e.preventDefault();

    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { edit_sales_order_items } = getState().sales_order;
    let name = e.target.name;
    edit_sales_order_items[index][name] = parseFloat(e.target.value);

    dispatch({
        type: HANDLE_SI_EDIT_INPUT_ROW,
        payload: edit_sales_order_items,
    });
};

// handle update row
export const handleUpdateRow = (index) => async (dispatch, getState) => {
    let { edit_sales_order_items } = getState().sales_order;

    let qty = edit_sales_order_items[index].qty;
    let srp = edit_sales_order_items[index].srp;

    if (qty == 0 || isNaN(qty)) {
        ToastDanger('Qty is required and cannot be a string value');
    } else if (srp == 0 || isNaN(srp)) {
        ToastDanger('Srp is required and cannot be a string value');
    } else {
        let updated_amount = srp * qty;
        edit_sales_order_items[index].amount = updated_amount;

        dispatch({
            type: HANDLE_SI_EDIT_UPDATE_ROW,
            payload: edit_sales_order_items,
        });
    }
};

// handle select sales order templates
export const handleSelectSalesOrderTemplate =
    (selectedOption) => async (dispatch) => {
        if (selectedOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        let template_id = selectedOption.value;
        let template_name = selectedOption.name;

        let si_default_template = {
            value: selectedOption.value,
            label: selectedOption.label,
        };

        dispatch({
            type: HANDLE_SELECT_SI_TEMPLATE,
            payload: { si_default_template, template_id, template_name },
        });
    };

// handle select status receipt type
export const handleSelectReceiptType =
    (selectedOption) => async (dispatch, getState) => {
        if (selectedOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        let default_select_type_receipt = {
            value: selectedOption.value,
            label: selectedOption.label,
        };

        // Check if the selected option is 'charge sales invoice' and payment terms is 'none'
        const { single_sales_order } = getState().sales_order;
        const payment_terms = single_sales_order.payment_terms.value;
        if (
            selectedOption.value === 'charged sales invoice' &&
            payment_terms === 'none'
        ) {
            ToastDanger(
                'You cannot select charge sales invoice if payment terms is none'
            );
            selectedOption = {
                value: 'none',
                label: ' None',
            };
        } else if (
            selectedOption.value != 'charged sales invoice' &&
            payment_terms != 'none'
        ) {
            ToastDanger(
                'You cannot select different receipt type if you selected a payment terms'
            );
            selectedOption = {
                value: 'charged sales invoice',
                label: 'Charged Sales Invoice',
            };
        }

        dispatch({
            type: HANDLE_SI_SELECT_TYPE_RECEIPT,
            payload: {
                default_select_type_receipt: default_select_type_receipt,
                receipt_type: selectedOption,
            },
        });
    };

// fetch sales order templates
export const getOrderTemplates = () => async (dispatch) => {
    SalesOrderService.getInvTemplates()
        .then((res) => {
            let sales_order_templates = res.data.sales_order_templates;
            let si_default_template = {
                value: res.data.selected_template._id,
                label: res.data.selected_template.template_name,
            };
            let template_id = res.data.sales_order_template_id;
            let template_name = res.data.selected_template.template_label;

            let si_template_arr = [];
            sales_order_templates.map((val, i) => {
                let select = {
                    value: val._id,
                    label: val.template_name,
                    name: val.template_label,
                };

                si_template_arr[i] = select;
            });

            dispatch({
                type: GET_SI_TEMPLATES,
                payload: {
                    sales_order_templates: si_template_arr,
                    si_default_template: si_default_template,
                    template_id: template_id,
                    template_name,
                },
            });
        })
        .catch((error) => {
            ToastDanger('Network error, please reload the page.');
            $('.btn-remove').removeAttr('disabled').html('Remove');
            console.log(error);
        });
};

// get all the terms and conditions
export const getTermsConditions = () => async (dispatch) => {
    SalesOrderService.getTermsConditions()
        .then((res) => {
            let terms_arr = [];
            let terms = res.data.terms_conditions;

            terms.map((val, i) => {
                let select = { value: val.content, label: val.title };
                terms_arr[i] = select;
            });

            terms_arr.unshift({ value: 'none', label: 'None' });

            dispatch({ type: GET_SI_TERMS_CONDITIONS, payload: terms_arr });
        })
        .catch((error) => {
            ToastDanger('Network error, please reload the page.');
            console.log(error);
        });
};

// get all the select options
export const getCustomers =
    (search = '') =>
    async (dispatch) => {
        const formdata = {
            search: search,
        };
        SalesOrderService.getCustomers(formdata)
            .then((res) => {
                let customers_arr = [];
                let customers = res.data.docs;

                customers.map((val, i) => {
                    let select = {
                        value: val._id,
                        label: val.name,
                        name: 'customer_id',
                    };
                    customers_arr[i] = select;
                });

                dispatch({ type: GET_SI_CUSTOMERS, payload: customers_arr });
            })
            .catch((error) => {
                if (error.data.errors.length > 0) {
                    error.data.errors.map((err) => ToastDanger(err));
                } else {
                    ToastDanger('Network error, please reload the page.');
                }
                console.log(error);
            });
    };

// get all the select options
export const searchCustomers = (search) => async (dispatch) =>
    new Promise((resolve, reject) => {
        const formdata = {
            search: search,
        };
        SalesOrderService.getCustomers(formdata)
            .then((res) => {
                let customers_arr = [];
                let customers = res.data.docs;

                customers.map((val, i) => {
                    let select = {
                        value: val._id,
                        label: val.name,
                        name: 'customer_id',
                    };
                    customers_arr[i] = select;
                });
                resolve(customers_arr);
                // dispatch({ type: GET_SI_CUSTOMERS, payload: customers_arr });
            })
            .catch((error) => {
                // ToastDanger('Network error, please reload the page.');
                console.log(error);
                reject(error);
            });
    });

// get the products
export const getProducts =
    (search = '') =>
    async (dispatch) => {
        const formdata = {
            search: search,
        };
        SalesOrderService.getProducts(formdata)
            .then((res) => {
                let items_arr = [];
                let items = res.data.docs;

                // console.log(items)

                items.map((item, i) => {
                    // console.log("item", item);
                    let attribute = '';
                    // if(item.attribute_string === '()' || item.attribute_string === null){
                    //     attribute = '';
                    // }
                    // else{

                    //     try
                    //     {
                    //         let attr_replace_char = item.attribute_string.replace('(','').replace(')', '');
                    //         attribute = attr_replace_char.slice(0, 40) + (attr_replace_char.length > 40 ? "..." : "");
                    //     }
                    //     catch(err){
                    //         attribute = '';
                    //     }

                    // }

                    // let select = {
                    //     _id: item._id,
                    //     value: item._id,
                    //     label: item.product_name,
                    //     sub_label: attribute,
                    //     name: 'item',
                    //     product_name: item.product_name,
                    //     barcode: item.barcode,
                    //     sku: item.sku,
                    //     qty: 1,
                    //     product_unit_id: item.product_unit_id ? item.product_unit_id : '',
                    //     product_unit_name: item.product_unit !== null ? item.product_unit.name : '',
                    //     attribute_string: item.attribute_string,
                    //     srp: item.srp,
                    //     unit_price: item.srp, // this is editable new field
                    //     amount: item.srp,
                    //     description : item.description,
                    //     lot_no : item.single_lot != null && item.single_lot != undefined ? item.single_lot.lot_no : '',
                    //     status_code : item.status_code
                    // }

                    let select = {
                        _id: item._id,
                        value: item._id,
                        label: item.product_name,
                        name: 'item',
                        product_name: item.product_name,
                        barcode: item.barcode,
                        brand: item.brand,
                        sku: item.sku,
                        qty: 1,
                        instock: item.instock,
                        product_unit_name: item.product_unit || '',
                        srp: item.srp,
                        unit_price: item.srp, // this is editable new field
                        amount: item.srp,
                        description: item.description,
                        selected_lot_no: [],
                    };

                    items_arr[i] = select;
                });

                dispatch({ type: GET_SI_PRODUCTS, payload: items_arr });
            })
            .catch((error) => {
                if (error.data.errors.length > 0) {
                    error.data.errors.map((err) => ToastDanger(err));
                } else {
                    ToastDanger('Network error, please reload the page.');
                }
                console.log(error);
            });
    };

export const searchProducst = (search, index) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
        // do something was a success
        const formdata = {
            search: search,
        };
        SalesOrderService.getProducts(formdata)
            .then((res) => {
                let items_arr = [];
                let items = res.data.docs;
                items.map((item, i) => {
                    let attribute = '';
                    if (
                        item.attribute_string == '()' ||
                        item.attribute_string === null
                    ) {
                        attribute = '';
                    } else {
                        try {
                            let attr_replace_char = item.attribute_string
                                .replace('(', '')
                                .replace(')', '');
                            attribute =
                                attr_replace_char.slice(0, 40) +
                                (attr_replace_char.length > 40 ? '...' : '');
                        } catch (err) {
                            attribute = '';
                        }
                    }

                    let select = {
                        _id: item._id,
                        value: item._id,
                        label: item.product_name,
                        sub_label: attribute,
                        name: 'item',
                        barcode: item.barcode,
                        brand: item.brand,
                        brand_id: item.brand_id,
                        product_name: item.product_name,
                        sku: item.sku,
                        qty: 1,
                        instock: item.instock,
                        product_unit_name: item ? item.product_unit_name : '',
                        product_unit_id: item.product_unit_id,
                        category: item.category,
                        category_id: item.category_id,
                        attribute_string: item.attribute_string,
                        srp: item.srp,
                        amount: item.srp,
                        status_code: item.status_code,
                        description: item.description,
                        unit_price: item.srp,
                        unit_srp: item.srp,
                        product_units: item.product_units,
                        conversion_to_base: item.conversion_to_base,
                        unit_barcode: item.unit_barcode || item.barcode,
                        selected_lot_no: [],
                    };

                    //items_arr[i] = select;
                    items_arr.push(select);
                });
                resolve(items_arr);
            })
            .catch((error) => {
                // ToastDanger('Network error, please reload the page.');
                console.log(error);
                reject();
            });

        // do something was a fail
    });

//  fetch
export const getSalesOrders =
    (pageNumber, rows_per_page = null, pageOrigin = null, date_filter = null) =>
    async (dispatch, getState) => {
        dispatch(setLoading(true));

        let {
            search,
            pagination,
            pagination_list,
            status_view,
            sort_order_name,
            sort_order_direction,
        } = getState().sales_order;
        let rows_per_page_val =
            rows_per_page != null ? rows_per_page : getNumRows('sales_order');

        // let params = {
        //     search: search,
        //     activePage: pagination.activePage,
        //     page: pageNumber,
        //     rows_per_page: rows_per_page_val,
        //     sort_order_name: sort_order_name,
        //     sort_order_direction: sort_order_direction
        // }

        //** MERN PAGINATE WITH OPTIMIZE SEARCH QUERY */
        let params = {
            search: search,
            options: {
                page: pageNumber,
                limit: rows_per_page_val || 10,
                sort_by: sort_order_name,
                sort_order: sort_order_direction,
            },
        };

        if (pageOrigin) {
            switch (pageOrigin['origin']) {
                case 'inventory_view':
                    params.product_id = pageOrigin['product_id'];
                    break;
                case 'customer_history':
                    params.customer_id = pageOrigin['customer_id'];
                default:
                    break;
            }
        }

        // Date Filtering
        if (date_filter) {
            params.date_from = date_filter['date_from'];
            params.date_to = date_filter['date_to'];
        }

        //console.log(params)

        // console.log(params);
        SalesOrderService.paginateWithSearchOrders(params, status_view)
            .then((res) => {
                let data_list = [];
                res.data.docs.map((data) => {
                    data_list.push(data);
                });

                pagination_list[status_view] = data_list;

                // let pagination = {
                //     totalCount: res.data.sales_orders.total,
                //     activePage: res.data.sales_orders.current_page,
                //     itemsCountPerPage: res.data.sales_orders.per_page,
                //     totalItemsCount: res.data.sales_orders.total
                // }

                //** MERN PAGINATE WITH OPTIMIZE SEARCH QUERY */
                let pagination = {
                    totalCount: res.data.total_docs,
                    activePage: res.data.page,
                    itemsCountPerPage: res.data.limit,
                    totalItemsCount: res.data.total_docs,
                };

                // let sales = [];
                // res.data.sales_orders.data.map((data) =>{
                //     data.sending_email = false;
                //     data.download_pdf = false;
                //     sales.push(data);
                // });

                let docs = res.data.docs;

                dispatch({
                    type: GET_SO_STATUS,
                    payload: {
                        pagination_list: pagination_list,
                        pagination: pagination,
                        sales_orders: docs,
                    },
                });
                dispatch(setLoading(false));
            })
            .catch((error) => {
                dispatch(setLoading(false));
                // ToastDanger('Network error, please reload the page.');
                console.log(error);
            });
    };

// get the sales order base on id
export const getSingleSalesOrder =
    (id, status = null) =>
    async (dispatch) => {
        dispatch(clearSalesOrder());
        dispatch(setMiniLoading(true));

        // SalesOrderService.getSingleSalesOrder(id).then(res => {
        //     if(res.data.status == 1)
        //     {
        //         let single_sales_order = res.data.sales_order;
        //         let sales_order_items = res.data.sales_order.items;
        //         let si_default_template = [];
        //         let subs_setting = res.data.subs_setting;

        //         dispatch(getSettingApp());
        //         const subsetting = getSubSetting();
        //         single_sales_order['default_tax'] = subsetting.tax_rate;

        //         if(single_sales_order['terms'] == null){
        //             single_sales_order['terms'] = subsetting.payment_terms ? subsetting.payment_terms : { value: 'none', label: 'None' };
        //         }

        //         if(single_sales_order['tax'] === null){
        //             single_sales_order['tax'] = 0;
        //         }

        //         if(single_sales_order.receipt_type == null){
        //             single_sales_order['receipt_type'] = { value: 'sales order', label: 'Sales Order' };
        //         }

        //         let edit_attr = {
        //             discount: res.data.sales_order.discount ? res.data.sales_order.discount : 0,
        //             vat: res.data.sales_order.vat ? res.data.sales_order.vat : 0,
        //             other:  res.data.sales_order.other ? res.data.sales_order.other : 0.00
        //         }

        //         let default_customer_value = { value: single_sales_order.customer._id, label: single_sales_order.customer.name };

        //         if(single_sales_order.template_setting != null)
        //         {
        //             si_default_template = { value: single_sales_order.template_setting._id, label: single_sales_order.template_setting.template_name  };
        //         }

        //         let sales_order_items_arr = [];
        //         // console.log("sales_order_items", sales_order_items);
        //         sales_order_items.map(item => {
        //             let status_code = item.products ? item.products.status_code : 0;
        //             let formatted = { ...item, _sales_order_item_id: item._id, status_code : status_code}
        //             sales_order_items_arr.push(formatted)
        //         })

        //         single_sales_order.sales_order_date = single_sales_order.sales_order_date ? new Date(single_sales_order.sales_order_date) : new Date();
        //         single_sales_order.subs_setting = subs_setting;
        //         single_sales_order.total =  single_sales_order.grand_total;

        //         dispatch({ type: GET_SINGLE_SALES_ORDER,
        //             payload: {
        //                 single_sales_order: single_sales_order,
        //                 sales_order_items: sales_order_items_arr,
        //                 edit_attr: edit_attr,
        //                 default_customer_value: default_customer_value,
        //                 si_default_template: si_default_template,
        //                 subs_setting: res.data.subs_setting
        //             }
        //         })
        //     }

        //     if(status == 'delete')
        //     {
        //         dispatch(archive());
        //     }

        //     dispatch(setMiniLoading(false));

        // })
        // .catch(error => {
        //     dispatch(setMiniLoading(false));
        //     ToastDanger('Network error, please reload the page.');
        //     console.log(error);
        // });

        try {
            const res = await SalesOrderService.getSingleSalesOrder(id);

            if (res.data.status === 1) {
                let single_sales_order = res.data.docs;
                let sales_order_items = res.data.docs.sales_order_items;
                let si_default_template = [];
                let subs_setting = res.data.subs_setting;

                // console.log(single_sales_order)

                // dispatch(getSettingApp());
                // const subsetting = getSubSetting();
                // single_sales_order['default_tax'] = subsetting.tax_rate;

                if (single_sales_order['payment_terms'] === null) {
                    single_sales_order['terms'] = single_sales_order[
                        'payment_terms'
                    ] || { value: 'none', label: 'None' };
                }

                single_sales_order['payment_mode'] =
                    single_sales_order.payment_mode || { label: '' };

                single_sales_order['payment_type'] =
                    single_sales_order.payment_mode;
                single_sales_order['quotation_no'] =
                    single_sales_order.reference_no || null;
                single_sales_order['quotation_id'] =
                    single_sales_order.reference_id || null;

                // if(single_sales_order['tax'] === null){
                //     single_sales_order['tax'] = 0;
                // }

                // if(single_sales_order.receipt_type === null){
                //     single_sales_order['receipt_type'] = { value: 'sales order', label: 'Sales Order' };
                // }

                let edit_attr = {
                    discount: single_sales_order.discount
                        ? single_sales_order.discount
                        : 0,
                    vat: single_sales_order.vat ? single_sales_order.vat : 0,
                    other: single_sales_order.other
                        ? single_sales_order.other
                        : 0.0,
                };

                let default_customer_value = {
                    value: single_sales_order.customer._id,
                    label: single_sales_order.customer.name,
                };

                if (single_sales_order.template_setting != null) {
                    si_default_template = {
                        value: single_sales_order.template_setting._id,
                        label: single_sales_order.template_setting.template_name
                            ? single_sales_order.template_setting.template_name
                            : single_sales_order.template.template_name,
                    };
                }

                // let sales_order_items_arr = [];
                // console.log("sales_order_items", sales_order_items);
                sales_order_items.map((item, index) => {
                    sales_order_items[index].unit_srp =
                        item.srp * item.conversion_to_base;
                });

                single_sales_order.sales_order_date =
                    single_sales_order.sales_order_date
                        ? new Date(single_sales_order.sales_order_date)
                        : new Date();
                single_sales_order.total = single_sales_order.total;
                // single_sales_order.subs_setting = subs_setting;

                const _payload = {
                    single_sales_order: single_sales_order,
                    sales_order_items: sales_order_items,
                    edit_attr: edit_attr,
                    default_customer_value: default_customer_value,
                    si_default_template: si_default_template,
                    // subs_setting: res.data.subs_setting
                };
                //console.log( _payload )

                dispatch({ type: GET_SINGLE_SALES_ORDER, payload: _payload });
            }

            if (status == 'delete') {
                dispatch(archive());
            }

            dispatch(setMiniLoading(false));
        } catch (error) {
            dispatch(setMiniLoading(false));
            ToastDanger('Network error, please reload the page.');
            console.log(error);
        }
    };

// handle submit form
export const handleOnSubmit =
    (method, status) => async (dispatch, getState) => {
        const { single_sales_order } = getState().sales_order;
        if (single_sales_order.is_manual) {
            single_sales_order.quotation_id = null;
        }

        let errors = [];
        single_sales_order.sales_order_items.map((item) => {
            if (item.qty <= 0) {
                errors.push(
                    'Quantity cannot be zero value, please add at least 1'
                );
            }
            if (item.srp <= 0) {
                errors.push(
                    'Unit Price cannot be zero value, please include at least the amount'
                );
            }
            // console.log('sku', item);
            if (item.sku === '') {
                errors.push('SKU is required, please add one');
            }

            if (item.product_name === '') {
                errors.push('Product name is required, please add one');
            }
        });

        if (
            (single_sales_order.discount_type.value === 'percent' ||
                single_sales_order.discount_type.value === 'amount') &&
            single_sales_order.discount === 0
        ) {
            errors.push(
                "Discount cannot be 0. Select 'None' if you don't want any discount."
            );
        }

        if (single_sales_order.sales_order_items.length == 0) {
            ToastDanger('Please add Product item at least one.');
        } else if (errors.length > 0) {
            ToastDanger(errors);
        } else {
            let stat_arr = status.split('-');
            let stat = stat_arr[0];
            let actions = stat_arr[1] !== undefined ? stat_arr[1] : null;
            // console.log("single_sales_order.sales_order_items", single_sales_order.sales_order_items);
            const data = {
                _id: single_sales_order._id,
                sales_order_no: single_sales_order.sales_order_no,
                transaction_no: single_sales_order.transaction_no,
                serial_no: single_sales_order.serial_no,
                reference_id: single_sales_order.quotation_id || null,
                reference_no: single_sales_order.is_manual
                    ? single_sales_order.reference_no
                    : single_sales_order.quotation_no,
                customer: single_sales_order.customer,
                customer_id: single_sales_order.customer_id,
                sales_order_items: single_sales_order.sales_order_items,
                discount: single_sales_order.discount,
                discount_type: single_sales_order.discount_type,
                vat_amount: single_sales_order.vat_amount,
                tax: single_sales_order.tax,
                tax_type: single_sales_order.tax_type,
                other: single_sales_order.other,
                sub_total: single_sales_order.sub_total,
                total: single_sales_order.total,
                remarks: single_sales_order.remarks,
                terms_and_condition: single_sales_order.terms_and_condition,
                payment_details: single_sales_order.payment_details,
                internal_notes: single_sales_order.internal_notes,
                payment_terms: single_sales_order.payment_terms,
                payment_mode: single_sales_order.payment_type,
                template_id: single_sales_order.template_id,
                payment: single_sales_order.payment,
                receipt_type: single_sales_order.receipt_type,
                status: stat,
                sales_order_date: single_sales_order.sales_order_date,
            };

            // console.log(data);
            if (single_sales_order.is_manual == true) {
                data['is_manual'] = true;

                // if (data['reference_no'] === null || data['reference_no'] === '') {
                //     ToastDanger('Reference No field is required.');
                //     return; // This will exit the function and stop further execution
                // }
            } else {
                data['is_manual'] = false;
            }

            //console.log("actions", actions);
            if (method === 'create') {
                // if(status == 'draft') return dispatch(salesOrderPost(data));
                // if(status == 'saved') return SwalWarning('Are You Sure?','You are about to save Sales Order, saving this will stop you from editing any other changes. Continue?', () => dispatch(salesOrderPost(data)))
                // if(status == 'saved-email') return SwalWarning('Are You Sure?','You are about to save and send to email this Sales Order, saving this will stop you from editing any other changes. Continue?', () => dispatch(salesOrderPost(data, true)))

                if (status === 'draft') {
                    data['status'] = 'draft';
                    return dispatch(salesOrderPost(data, actions));
                }
                if (status === 'draft-print') {
                    data['status'] = 'draft';
                    return dispatch(salesOrderPost(data, actions));
                }
                if (status === 'draft-email') {
                    data['status'] = 'draft';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to draft and email this Sales Order. Continue?',
                        () => dispatch(salesOrderPost(data, actions))
                    );
                }
                // if(status == 'saved' || status == 'saved-print') return SwalWarning('Are You Sure?','You are about to save Sales Order, saving this will stop you from editing any other changes. Continue?', () => dispatch(salesOrderPost(data, actions)))

                if (status === 'saved') {
                    data['status'] = 'saved';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to save Sales Order, saving this will stop you from editing any other changes. Continue?',
                        () => dispatch(salesOrderPost(data, actions))
                    );
                }

                if (status === 'saved-print') {
                    data['status'] = 'saved';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to save Sales Order, saving this will stop you from editing any other changes. Continue?',
                        () => dispatch(salesOrderPost(data, actions))
                    );
                }

                if (status === 'saved-email') {
                    data['status'] = 'saved';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to save and email this Sales Order, saving this will stop you from editing any other changes. Continue?',
                        () => dispatch(salesOrderPost(data, actions))
                    );
                }
            } else {
                // update
                // if(status == 'draft') return dispatch(updateSingleSalesOrder(data, data._id));
                // if(status == 'saved') return SwalWarning('Are You Sure?','You are about to save Sales Order, saving this will stop you from editing any other changes. Continue?', () => dispatch(updateSingleSalesOrder(data, data._id)))

                // if(status == 'draft' || status == 'draft-print') return dispatch(updateSingleSalesOrder(data, data._id, actions));

                if (status === 'draft') {
                    data['status'] = 'draft';
                    return dispatch(
                        updateSingleSalesOrder(data, data._id, actions)
                    );
                }

                if (status === 'draft-print') {
                    data['status'] = 'draft';
                    return dispatch(
                        updateSingleSalesOrder(data, data._id, actions)
                    );
                }

                if (status === 'draft-email') {
                    data['status'] = 'draft';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to draft and email this Sales Order. Continue?',
                        () =>
                            dispatch(
                                updateSingleSalesOrder(data, data._id, actions)
                            )
                    );
                }

                if (status === 'saved') {
                    data['status'] = 'saved';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to save Sales Order, saving this will stop you from editing any other changes. Continue?',
                        () =>
                            dispatch(
                                updateSingleSalesOrder(data, data._id, actions)
                            )
                    );
                }

                if (status === 'saved-print') {
                    data['status'] = 'saved';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to save Sales Order, saving this will stop you from editing any other changes. Continue?',
                        () =>
                            dispatch(
                                updateSingleSalesOrder(data, data._id, actions)
                            )
                    );
                }

                if (status == 'saved-email') {
                    data['status'] = 'saved';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to save and send email this Sales Order, saving this will stop you from editing any other changes. Continue?',
                        () =>
                            dispatch(
                                updateSingleSalesOrder(data, data._id, actions)
                            )
                    );
                }

                // if(status == 'saved' || status == 'saved-print') return SwalWarning('Are You Sure?','You are about to save Sales Order, saving this will stop you from editing any other changes. Continue?', () => dispatch(updateSingleSalesOrder(data, data._id, actions)))
                // if(status == 'saved-email'){
                //     data['send_to_email'] = true;
                //     return SwalWarning('Are You Sure?','You are about to save and send email this Sales Order, saving this will stop you from editing any other changes. Continue?', () => dispatch(updateSingleSalesOrder(data, data._id, actions)))
                // }
            }
        }
    };

// store
export const salesOrderPost = (data, actions) => async (dispatch) => {
    dispatch(setMiniLoading(true));
    dispatch(setMUIPage(1));
    try {
        const res = await SalesOrderService.SalesOrderCreate(data);
        if (res.data.status == 0) {
            ToastDanger(res.data.errors);
        } else if (res.data.status == 1) {
            dispatch(setPage('main_page'));
            ToastSuccess(res.data.message);

            if (actions == 'print') {
                dispatch(setPage('print_modal_si', res.data.so.data._id));
            } else if (actions == 'email') {
                dispatch(sendEmail(null, res.data.so.data._id));
            }
        }
        $('.btn-save').removeAttr('disabled').html('Save');
    } catch (error) {
        if (error.data.errors.length > 0) {
            dispatch(setMiniLoading(false));
            ToastDanger(error.data.errors);
        } else {
            ToastDanger('Network error, please reload the page.');
        }
        console.log(error);
    }
};

// update
export const updateSingleSalesOrder =
    (data, id, actions) => async (dispatch) => {
        dispatch(setLoading(true));
        SalesOrderService.updateSingleSalesOrder(data, id)
            .then((res) => {
                // switch(res.data.status){
                //     case 0:
                //         ToastDanger(res.data.errors);
                //         break;
                //     case 1:
                //         dispatch(setPage('main_page'));
                //         ToastSuccess(res.data.message);
                //         break;
                //     default:
                //         break;
                // }

                if (res.data.status == 0) {
                    ToastDanger(res.data.errors);
                } else if (res.data.status == 1) {
                    dispatch(setPage('main_page'));
                    ToastSuccess(res.data.message);
                    if (actions == 'print') {
                        dispatch(
                            setPage(
                                'print_modal_si',
                                res.data.salesOrder.data._id
                            )
                        );
                    } else if (actions == 'email') {
                        dispatch(sendEmail(null, res.data.salesOrder.data._id));
                    }
                }

                dispatch(setLoading(false));
                $('.btn-save').removeAttr('disabled').html('Save');
            })
            .catch((error) => {
                if (error.data.errors.length > 0) {
                    ToastDanger(error.data.errors);
                } else {
                    ToastDanger('Network error, please reload the page.');
                }
                dispatch(setLoading(false));
                console.log(error);
            });
    };

// archieve
export const moveToArchive =
    (pageOrigin = null) =>
    async (dispatch, getState) => {
        let { rows_to_delete } = getState().sales_order;
        let id_arr = [];

        rows_to_delete.map((row) => {
            id_arr.push(row.id);
        });
        let params = { ids: JSON.stringify(id_arr) };

        SalesOrderService.ArchiveOrder(params)
            .then((res) => {
                dispatch(setRowChecked());
                switch (res.data.status) {
                    case 0:
                        ToastWarning(res.data.message);
                        if (pageOrigin !== null) {
                            if (pageOrigin['origin'] == 'customer_history') {
                                dispatch(getSalesOrders(1, null, pageOrigin));
                            }
                        } else {
                            dispatch(clearSalesOrder());
                            dispatch(getSalesOrders());
                        }
                        break;
                    case 1:
                        ToastSuccess(res.data.message);
                        if (pageOrigin !== null) {
                            if (pageOrigin['origin'] == 'customer_history') {
                                dispatch(getSalesOrders(1, null, pageOrigin));
                            }
                        } else {
                            dispatch(clearSalesOrder());
                            dispatch(getSalesOrders());
                        }
                    default:
                        break;
                }
            })
            .catch((error) => {
                if (error.data.errors.length > 0) {
                    error.data.errors.map((err) => ToastDanger(err));
                } else {
                    ToastDanger('Network error, please reload the page.');
                    console.log(error);
                }
                // ToastDanger('Network error, please reload the page.');
            });
    };

export const archive = () => async (dispatch, getState) => {
    let { single_sales_order } = getState().sales_order;

    SwalWarning(
        'Warning!',
        `Do you want to remove the Sales Order No: ${single_sales_order.sales_order_no}?`,
        () => dispatch(moveToArchive())
    );
};

export const setModal = (modal, status) => async (dispatch) => {
    dispatch({ type: SET_MODAL, payload: { modal: modal, status: status } });
};

// Check manual
export const handleCheckManual = (e) => async (dispatch, getState) => {
    let { sales_order_items } = getState().sales_order.single_sales_order;
    let checked = e.target.checked;
    let sales_order_items_arr = [];

    if (sales_order_items.length == 0) {
        dispatch({
            type: HANDLE_CHECK_MANUAL,
            payload: {
                is_manual: checked,
                sales_order_items: sales_order_items_arr,
            },
        });
    } else {
        SwalWarning(
            'Warning!',
            `Selected item(s) will be overwritten, continue?`,
            () => {
                dispatch({
                    type: HANDLE_CHECK_MANUAL,
                    payload: {
                        is_manual: checked,
                        sales_order_items: sales_order_items_arr,
                    },
                });
            }
        );
    }
};

// Get quotations
export const getQuotations = () => async (dispatch) => {
    let getParams = { use_select: true };

    SalesOrderService.getQuotations(getParams)
        .then((res) => {
            const quotations = res.data.docs;
            const quotation_options = [];

            // console.log(quotations)

            quotations.map((q) => {
                let select = { value: q._id, label: q.quotation_no };
                quotation_options.push(select);
            });

            dispatch({ type: SO_GET_QUOTATIONS, payload: quotation_options });
        })
        .catch((error) => {
            // ToastDanger('Network error, please reload the page.');
            console.log(error);
        });
};

// select quotation
export const handleSelectQuotation =
    (selectOption, current_sales_order_id) => async (dispatch) => {
        // console.log(selectOption)
        if (selectOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        dispatch(setMiniLoading(true));
        SalesOrderService.getSingleQuotation(selectOption.value)
            .then((res) => {
                // console.log(res.data)
                let single_quotation = res.data.docs;
                let quotation_items = res.data.docs.quotation_items;
                // Check if the current sales_order has an id
                if (current_sales_order_id) {
                    // Replace the single_quotation id with the current sales_order id
                    single_quotation._id = current_sales_order_id;
                }

                if (single_quotation['payment_terms'] == null) {
                    single_quotation['terms'] = {
                        value: '',
                        label: 'Choose Terms',
                    };
                } else {
                    single_quotation['terms'] =
                        single_quotation['payment_terms'];
                }

                if (single_quotation['payment_mode'] == null) {
                    single_quotation['payment_type'] = {
                        value: 'none',
                        label: 'None',
                    };
                } else {
                    single_quotation['payment_type'] =
                        single_quotation['payment_mode'];
                }

                if (single_quotation.receipt_type == null) {
                    single_quotation['receipt_type'] = {
                        value: 'sales order',
                        label: 'Sales Order',
                    };
                }

                let edit_attr = {
                    discount: single_quotation.discount
                        ? single_quotation.discount
                        : 0,
                    vat: single_quotation.vat ? single_quotation.vat : 0,
                    other: single_quotation.other
                        ? single_quotation.other
                        : 0.0,
                };

                let default_customer_value = {
                    value: single_quotation.customer._id,
                    label: single_quotation.customer.name,
                };

                let quotation_items_arr = [];

                quotation_items.map((item) => {
                    let formatted = {
                        ...item,
                        _sales_order_item_id: item._id,
                        unit_price: item.unit_price,
                        unit_srp: item.srp * item.conversion_to_base,
                    };
                    quotation_items_arr.push(formatted);
                });

                // quotation select
                single_quotation['quotation_no'] = selectOption.label;
                single_quotation['quotation_id'] = selectOption.value;

                single_quotation.status = null;

                let dataPayload = {
                    single_sales_order: single_quotation,
                    sales_order_items: quotation_items_arr,
                    edit_attr: edit_attr,
                    default_customer_value: default_customer_value,
                };

                //console.log(dataPayload)

                dispatch({
                    type: HANDLE_SO_SELECT_QUOTATION,
                    payload: dataPayload,
                });
            })
            .catch((error) => {
                ToastDanger('Network error, please reload the page.');
                console.log(error);
                dispatch(setMiniLoading(false));
            });

        dispatch(setMiniLoading(false));
    };

// handle input datepicker
export const SIDatePicker = (date) => async (dispatch) => {
    if (date) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    dispatch({ type: SET_DATE_PICKER, payload: date });
};

// Sort by column name and direction
export const sortTableByColumn =
    (sort_order_name, sort_order_direction, pageOrigin = null) =>
    async (dispatch) => {
        let sortingParams = {
            sort_order_name: sort_order_name,
            sort_order_direction: sort_order_direction,
        };

        dispatch({ type: SORT_BY_COLUMN, payload: sortingParams });
        dispatch(getSalesOrders(1, null, pageOrigin));
    };

export const handleSearchInputMUI = (e) => async (dispatch) => {
    dispatch({ type: SEARCH_INPUT, payload: e.target.value });
    // dispatch(getSalesOrders(1));
};

// returns selected rows only
export const getSelectedRows =
    (selectedRows, currentRows) => async (dispatch) => {
        // console.log(selectedRows, currentRows)
        let newArray = [];

        currentRows.map((current, i) => {
            selectedRows.map((selected, _i) => {
                if (selected.index == current.index) {
                    let selected = {
                        id: current.data[0],
                        name: current.data[1],
                    };
                    newArray.push(selected);
                }
            });
        });
        // console.log(newArray);
        dispatch({ type: GET_ROWS_TO_DELETE, payload: newArray });
    };

export const confirmDeleteDialogBox =
    (pageOrigin) => async (dispatch, getState) => {
        let { rows_to_delete } = getState().quotation;
        let sales_order_no = [];
        rows_to_delete.map((rows, i) => {
            sales_order_no.push('<b>' + rows.name + '</b>');
        });
        SwalWarningHtml(
            'Warning!',
            `Do you want to remove the Sales Order(s): ${sales_order_no.join(
                ', '
            )}?`,
            () => dispatch(moveToArchive(pageOrigin))
        );
    };

// set the rows unchecked
export const setRowChecked = () => async (dispatch) =>
    dispatch({ type: SET_ROW_CHECKED });

// handle prev, next page of modals
export const goPage = (direction) => async (dispatch, getState) => {
    dispatch(setMiniLoading(true));
    let {
        single_sales_order: { _id },
    } = getState().sales_order;

    let params = {
        direction,
        _id,
    };

    try {
        const go_to = await SalesOrderService.goPage(params);
        dispatch(getSingleSalesOrder(go_to.data._id));
    } catch (e) {
        console.log(e);
        ToastDanger('Server Error');
        dispatch(setMiniLoading(false));
    }
};

export const add_items = () => async (dispatch, getState) => {
    let { single_sales_order, item_template } = getState().sales_order;
    let items_data = single_sales_order.sales_order_items;
    item_template.new = true;

    let errors = [];
    items_data.map((item) => {
        if (item.qty <= 0) {
            errors.push('Quantity cannot be zero value, please add at least 1');
        }
        // if(item.srp <= 0){
        //     errors.push('Unit Price cannot be zero value, please include at least the amount');
        // }
    });

    if (errors.length > 0) {
        ToastDanger(errors);
    } else {
        items_data.push(item_template);
        dispatch({ type: ADD_ITEM, payload: items_data });
    }
};

export const dynamicInputChange = (e, index) => async (dispatch, getState) => {
    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { name, value } = e.target;
    let { single_sales_order } = getState().sales_order;
    let items = { ...single_sales_order.sales_order_items[index] };

    // console.log(' items', items);

    if (name == 'qty') {
        // Allow empty string for typing UX, otherwise parse and remove leading zeros
        if (value === '') {
            items[name] = '';
        } else {
            // Allow decimal for kilogram units
            const kgUnits = ['kg', 'KG', 'Kg', 'kilogram', 'Kilogram', 'KILOGRAM'];
            const isKgUnit = kgUnits.includes(items.product_unit_name);

            if (isKgUnit) {
                if (/^\d*\.?\d*$/.test(value)) {
                    if (value.endsWith('.') || value === '' || (value.includes('.') && String(parseFloat(value)) !== value)) {
                        items[name] = value; // Keep as string while typing
                    } else {
                        items[name] = parseFloat(value); // Convert to number
                    }
                } else {
                    e.target.value = String(items[name] ?? '');
                }
            } else {
                const parsed = parseInt(value, 10);
                items[name] = isNaN(parsed) ? '' : Math.max(0, parsed);
            }
        }
    } else if (
        name === 'product_name' ||
        name === 'product_unit_name' ||
        name === 'sku'
    ) {
        items[name] = value; // Keep as string
    } else {
        items[name] = parseFloat(value);
    }

    if (items.non_inventory) {
        items.srp = items.unit_price;
    }

    // Use 0 for calculation if qty is empty
    const qtyForCalc = items.qty === '' ? 0 : items.qty;

    // if unit_price is change srp will be disregard in the computation
    if (items.srp !== items.unit_price) {
        items.amount = parseFloat(qtyForCalc) * parseFloat(items.unit_price);
    } else {
        items.amount = parseFloat(qtyForCalc) * parseFloat(items.srp);
    }

    if (items.discount_type && items.discount_type.value !== 'none') {
        let discountAmount = 0;
        if (items.discount_type.value === 'percent') {
            discountAmount = (items.discount / 100) * items.amount;
        } else if (items.discount_type.value === 'amount') {
            discountAmount = items.discount;
        }
        items.amount = items.amount - discountAmount;
        items.discount_amount = discountAmount ? discountAmount : 0;
    }

    single_sales_order.sales_order_items[index] = items;
    dispatch({
        type: ADD_ITEM,
        payload: single_sales_order.sales_order_items,
    });

    let bool = false;
    // po_items.map((data, key) =>{
    //     if(data.cost <= 0 || data.srp <= 0 || data.order_qty <= 0)
    //     {
    //         bool = true;
    //     }
    // })
    // dispatch({type : BTN_SUB, payload : bool});
};

export const clear_customer = () => async (dispatch) => {
    let default_customer_value = { value: '', label: '' };
    dispatch({ type: SI_SET_CUSTOMER_DATA, payload: default_customer_value });
};

export const handleTaxType = (selectOption) => async (dispatch, getState) => {
    let { tax, default_tax } = getState().sales_order.single_sales_order;

    tax = selectOption.value === 'none' ? 0 : default_tax;

    dispatch({
        type: SI_SELECT_TAX_TYPE,
        payload: { tax, tax_type: selectOption },
    });
};

// COMPUTATION HANDLER
export const computationHandler = () => async (dispatch, getState) => {
    let {
        single_sales_order: {
            sales_order_items,
            discount,
            discount_type,
            tax,
            tax_type,
            other,
        },
    } = getState().sales_order;

    discount = parseFloat(discount) || 0;
    //console.log(discount_type, discount)

    // Subtotal and discount
    const sub_total = sales_order_items.reduce(
        (sub, item) => sub + parseFloat(item.amount ? item.amount : item.srp),
        0
    );
    const discounted =
        discount_type.value === 'percent'
            ? (parseFloat(sub_total) * discount) / 100
            : discount;
    const sub_total_discounted = sub_total - discounted + other;

    // Exclusive Vat     // Formula: price * (vat / 100)
    const exclusive_vat = (parseFloat(sub_total_discounted) * tax) / 100;
    //const total_w_exclusive = sub_total_discounted + ((parseFloat(sub_total_discounted) * tax) / 100) + other; // total amount
    const total_w_exclusive =
        sub_total_discounted + (parseFloat(sub_total_discounted) * tax) / 100; // total amount

    // Inclusive Vat   // Formula: price / ( (vat / 100) + 1)
    const inclusive_amount = sub_total_discounted / (tax / 100 + 1);
    const inclusive_vat = sub_total_discounted - inclusive_amount;

    let payload = {};
    switch (tax_type.value) {
        case 'exclusive':
            payload = {
                sub_total: sub_total,
                vat_amount: exclusive_vat,
                total: total_w_exclusive,
            };
            break;
        case 'inclusive':
            payload = {
                sub_total: sub_total,
                vat_amount: inclusive_vat,
                total: sub_total_discounted,
            };
            break;
        default:
            payload = {
                vat_amount: 0.0,
                sub_total: sub_total,
                total: sub_total_discounted,
            };
            break;
    }

    // console.log('COMPUTE HANDLER',payload);
    dispatch({ type: SI_COMPUTATION_HANDLER, payload });
};

export const sendEmail = (e, id) => async (dispatch, getState) => {
    let { email_config } = getState().sales_order;
    if (email_config.require_password) {
        verfiyPass(function (result) {
            dispatch(sendSingleEmail(id));
        });
    } else {
        dispatch(sendSingleEmail(id));
    }
};
const sendSingleEmail = (id) => async (dispatch, getState) => {
    dispatch({ type: SEND_EMAIL, payload: true });
    let { single_sales_order } = getState().sales_order;
    SalesOrderService.sendEmail(id)
        .then((result) => {
            ToastSuccess(result.data.message);
            dispatch({ type: SEND_EMAIL, payload: false });
            dispatch({ type: RESEND_EMAIL, payload: true });
        })
        .catch((err) => {
            if (err.data == undefined) {
                ToastDanger('Failed to send email.');
            } else {
                ToastDanger(err.data.message);
            }
            dispatch({ type: SEND_EMAIL, payload: false });
            dispatch({
                type: RESEND_EMAIL,
                payload: single_sales_order.email_sent,
            });
        });
};

export const reSendEmail = (e, id) => async (dispatch, getState) => {
    SwalWarning(
        'Are you sure?',
        'Do you really want to resend this email?',
        () => dispatch(sendEmail(e, id))
    );
};

export const sendEmailDyanmic =
    (e, id, index) => async (dispatch, getState) => {
        let { sales_orders } = getState().sales_order;
        if (sales_orders[index].email_sent) {
            SwalWarning(
                'Are you sure?',
                'Do you really want to resend this email?',
                () => dispatch(sendByIndex(id, index))
            );
        } else {
            dispatch(sendByIndex(id, index));
        }
    };

const sendByIndex = (id, index) => async (dispatch, getState) => {
    let { email_config } = getState().sales_order;
    if (email_config.require_password) {
        verfiyPass(function (result) {
            dispatch(sendEmailIndex(id, index));
        });
    } else {
        dispatch(sendEmailIndex(id, index));
    }
};

const sendEmailIndex = (id, index) => async (dispatch, getState) => {
    let { sales_orders } = getState().sales_order;
    let sales = sales_orders[index];
    sales.sending_email = true;
    sales_orders[index] = sales;
    dispatch({ type: DYNAMIC_SEND_EMAIL, payload: sales_orders });
    SalesOrderService.sendEmail(id)
        .then((result) => {
            ToastSuccess(result.data.message);
            sales.sending_email = false;
            sales.email_sent = true;
            sales_orders[index] = sales;
            dispatch({ type: DYNAMIC_SEND_EMAIL, payload: sales_orders });
        })
        .catch((err) => {
            // ToastDanger('Failed to send email.');
            if (err.data == undefined) {
                ToastDanger('Failed to send email.');
            } else {
                ToastDanger(err.data.message);
            }
            sales.sending_email = false;
            sales_orders[index] = sales;
            dispatch({ type: DYNAMIC_SEND_EMAIL, payload: sales_orders });
        });
};

export const getPdf = (e, id, sales_order_no, customer) => async (dispatch) => {
    dispatch({ type: DOWNLOAD_BTN, payload: true });
    SalesOrderService.getPdf(id)
        .then((result) => {
            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = url;
            let filename = `SO (${sales_order_no}) ${customer}.pdf`;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            dispatch({ type: DOWNLOAD_BTN, payload: false });
        })

        .catch((err) => {
            dispatch({ type: DOWNLOAD_BTN, payload: false });
            try {
                ToastDanger(err.data.message);
            } catch (error) {
                ToastDanger('Failed to generate PDF.');
            }
        });
};

export const dynamiPdf = (e, id, index) => async (dispatch, getState) => {
    let { sales_orders } = getState().sales_order;
    let sales = sales_orders[index];
    console.log('sales', sales);
    sales.download_pdf = true;
    sales_orders[index] = sales;
    dispatch({ type: DYNAMIC_SEND_EMAIL, payload: sales_orders });
    SalesOrderService.getPdf(id)
        .then((result) => {
            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = url;
            let filename = `SO (${sales.sales_order_no}) ${sales.customer}.pdf`;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();

            sales.download_pdf = false;
            sales_orders[index] = sales;
            dispatch({ type: DYNAMIC_SEND_EMAIL, payload: sales_orders });
        })

        .catch((err) => {
            sales.download_pdf = false;
            sales_orders[index] = sales;
            dispatch({ type: DYNAMIC_SEND_EMAIL, payload: sales_orders });
            try {
                ToastDanger(err.data.message);
            } catch (error) {
                ToastDanger('Failed to generate PDF.');
            }
        });
};

export const emailConfig = () => async (dispatch) => {
    let x = 0;

    while (x < 3) {
        try {
            const result = await SalesOrderService.getEmailConfig();
            dispatch({ type: EMAIL_SETTING_DATA, payload: result.data });
            x = 4;
        } catch (err) {
            // Temporary comment coz connection it timeout
            // ToastDanger('Failed to load email configuration.');
            console.log('error', err);
            x++;
        }
    }
};

const verfiyPass = (callback) => {
    SwallverfiyPass(function (password) {
        let formdata = {
            password: password,
            admin_email: getUserData().admin_email,
        };
        SalesOrderService.verifyPassword(formdata)
            .then((result) => {
                SwalSuccessAutoRemove(result.data.message, callback('success'));
            })
            .catch((err) => {
                console.log('err', err);
                try {
                    SwalError(err.data.message);
                } catch (error) {
                    console.log('error', error);
                    SwalError('Unknown error occured');
                }
                // reject(err)
            });
    });
};

export const clickedPaymentWarning = (si) => async (dispatch) => {
    if (si.payment_status === 'paid') {
        SwalVerifyUpdatePayment('Warning!', 'Please enter passcode', () =>
            dispatch(updatePaymentStatus(si))
        );
    } else {
        await dispatch(getSettingApp());
        const subsetting = getSubSetting();

        let priceCode = ''; // initial price value
        if (subsetting.currency.currency_name != null) {
            if (subsetting.currency.code.checked === true) {
                priceCode = subsetting.currency.code.value;
            }

            if (subsetting.currency.symbol.checked === true) {
                priceCode = subsetting.currency.symbol.value;
            }
        }

        SwalUpdatePayment(
            'Warning!',
            `Are you sure you want to mark as "Paid" <br> Sales Order No. ${si.serial_no} with the <br> price of ${priceCode}${si.total_price} `,
            () => dispatch(updatePaymentStatus(si))
        );
    }
};

export const updatePaymentStatus = (si) => async (dispatch) => {
    let resolve = {
        message: '',
        status: 0,
    };

    try {
        const res = await SalesOrderService.updatePaymentStatus(si);

        if (res.data.status === 1) {
            resolve.status = 1;
            resolve.message = res.data.message;

            dispatch(getSalesOrders());
        }
    } catch (err) {
        console.log(err);
        ToastDanger('Server Error');
    }

    return resolve;
};

export const cancelSi = () => async (dispatch, getState) => {
    let { single_sales_order } = getState().sales_order;
    // console.log("single_sales_order", single_sales_order);
    SwalWarningHtml(
        'Are You Sure?',
        'You are about to cancel Sales Order <b>' +
            single_sales_order.serial_no +
            '</b>. Continue?',
        () => dispatch(passwordCancel())
    );
};

const passwordCancel = () => async (dispatch) => {
    SwallverfiyPass(function (password) {
        let formdata = {
            password: password,
            admin_email: getUserData().admin_email,
            role_id: getUserData().role_id,
            subscriber_id: getUserData().subscriber_id,
            id: getUserData()._id,
        };
        SalesOrderService.verifyPassword(formdata)
            .then((result) => {
                SwalSuccessAutoRemove(
                    result.data.message,
                    dispatch(submitCancel())
                );
            })
            .catch((err) => {
                console.log('err', err);
                try {
                    SwalError(err.data.message);
                } catch (error) {
                    console.log('error', error);
                    SwalError('Unknown error occured');
                }
                // reject(err)
            });
    });
};

export const submitCancel = () => async (dispatch, getState) => {
    let { single_sales_order, btn_form } = getState().sales_order;
    btn_form.cancel = true;
    dispatch({ type: BTN_FORM, payload: btn_form });
    SalesOrderService.cancelOrder(single_sales_order._id)
        .then((result) => {
            btn_form.cancel = false;
            dispatch({ type: BTN_FORM, payload: btn_form });
            ToastSuccess(
                'Sales Order: ' + single_sales_order.serial_no + ' cancelled'
            );
            dispatch(setPage('main_page'));
        })
        .catch((err) => {
            btn_form.cancel = false;
            dispatch({ type: BTN_FORM, payload: btn_form });
            try {
                ToastDanger(err.data.message);
            } catch (err) {
                ToastDanger('Failed to cancel Sales Order');
            }
        });
};

//** Create product in form */
export const createProduct =
    (index, non_inventory) => async (dispatch, getState) => {
        if (!non_inventory) {
            let { single_sales_order } = getState().sales_order;
            let items = { ...single_sales_order.sales_order_items[index] };
            items.sku = '';
            single_sales_order.sales_order_items[index] = items;
            dispatch({
                type: ADD_ITEM,
                payload: single_sales_order.sales_order_items,
            });
        }

        dispatch({
            type: CREATE_PRODUCT,
            payload: { index, non_inventory },
        });
    };

//** handle form_disable */
export const handleFormDisable = (status) => async (dispatch) =>
    dispatch({ type: HANDLE_ITEM_FORM_DISABLE, payload: status });

//** sku validation */
export const skuSkipValidation = (e, index) => async (dispatch, getState) => {
    let { name, value } = e.target;
    let { single_sales_order } = getState().sales_order;
    let items = { ...single_sales_order.sales_order_items[index] };

    try {
        if (name === 'sku') {
            items[name] = value;
        }

        let params = {
            sku: items.sku,
        };

        await ProductService.skuSkipValidation(params);
        $('#sku').removeClass('is-invalid');
        dispatch(handleFormDisable(false));
    } catch (err) {
        if (err.data.errors) {
            ToastDanger(err.data.errors);
            $('#sku').addClass('is-invalid');
            dispatch(handleFormDisable(true));
        } else {
            ToastDanger('Network error, please reload the page.');
        }
        console.log(err);
    }
};

//** generate SKU */
export const generateSku = (e, index) => async (dispatch, getState) => {
    let { name, value } = e.target;
    let { single_sales_order } = getState().sales_order;
    let items = { ...single_sales_order.sales_order_items[index] };

    await ProductService.generateSku()
        .then((res) => {
            items.sku = res.data.sku;

            single_sales_order.sales_order_items[index] = items;
            dispatch({
                type: ADD_ITEM,
                payload: single_sales_order.sales_order_items,
            });
        })
        .catch((err) => {
            if (err.data.errors) {
                ToastDanger(err.data.errors);
            } else {
                ToastDanger('Network error, please reload the page.');
            }
            console.log(err);
        });
};

// handle select product unit for a row
export const handleSelectProductUnit =
    (selectedOption, index) => async (dispatch, getState) => {
        if (selectedOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        let { single_sales_order } = getState().sales_order;

        let updatedItems = [...single_sales_order.sales_order_items];
        let updatedItem = { ...updatedItems[index] };

        // console.log('selectedOption', selectedOption);

        updatedItem.product_unit_id = selectedOption.product_unit_id;
        updatedItem.product_unit_name = selectedOption.name;
        updatedItem.conversion_to_base = selectedOption.conversion_to_base;
        updatedItem.unit_barcode = selectedOption.barcode;
        updatedItem.unit_price =
            updatedItem.srp * updatedItem.conversion_to_base;
        updatedItem.unit_srp = updatedItem.srp * updatedItem.conversion_to_base;
        updatedItem.amount = updatedItem.unit_price * updatedItem.qty;

        updatedItems[index] = updatedItem;
        dispatch({
            type: ADD_ITEM,
            payload: updatedItems,
        });
    };

export const getProductLot =
    (id, qty, conversion_to_base, product_unit_name, itemIndex) =>
    async (dispatch, getState) => {
        dispatch(setLoading(true));
        SalesOrderService.getProductLot(id)
            .then((result) => {
                dispatch({
                    type: SET_SO_ITEM_ID,
                    payload: itemIndex, // ← record which row
                });

                // divide lot.quantity by conversion_to_base, floor to a whole number
                // if quantity is 0, then remove it in the lotData
                const lotData = result.data.result
                    .map((lot) => {
                        const qty = Math.floor(
                            lot.quantity / conversion_to_base
                        );
                        return {
                            ...lot,
                            conversion_to_base,
                            quantity: qty,
                            product_unit_name,
                        };
                    })
                    .filter((lot) => lot.quantity > 0);

                // console.log('lotData', lotData);
                dispatch({
                    type: GET_SO_PRODUCT_LOT,
                    payload: {
                        item_product_lot: lotData,
                        item_product_qty: qty,
                    },
                });
                dispatch(setLoading(false));
            })
            .catch((err) => {
                if (err.data == undefined) {
                    ToastDanger('Failed to get Product Lot.');
                } else {
                    ToastDanger(err.data.message);
                }
            });
    };

// handle product lot inputs
export const handleProductLotInput = (e) => async (dispatch) => {
    if (e.target.value !== '') {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    dispatch({
        type: SO_PRODUCT_LOT_INPUT_CHANGE,
        payload: { key: e.target.name, value: e.target.value },
    });
};

export const handleLotConfirm = () => async (dispatch, getState) => {
    const {
        sales_order: {
            item_product_lot,
            item_product_qty,
            product_lot_inputs,
            single_sales_order,
            item_id, // index of the item in sales_order_items
        },
    } = getState();

    if (!item_product_lot || item_product_lot.length === 0) {
        ToastDanger('No product lot records available.');
        return false;
    }

    const selectedLots = item_product_lot
        .map((lot) => {
            const qty = parseFloat(product_lot_inputs[`lot_${lot._id}`] || 0);
            return qty > 0
                ? {
                      lot_no: lot.lot_no,
                      order_qty: qty,
                  }
                : null;
        })
        .filter(Boolean);

    const selectedTotal = selectedLots.reduce(
        (sum, lot) => sum + lot.order_qty,
        0
    );

    const requiredQty = parseFloat(item_product_qty);

    if (selectedTotal !== requiredQty) {
        ToastDanger(
            `Selected lot quantity (${selectedTotal}) must match the required quantity (${requiredQty}).`
        );
        return false;
    }

    // ✅ Update item with selected lot info
    const items = [...single_sales_order.sales_order_items];
    if (!items[item_id]) {
        ToastDanger('Item not found for updating lot selection.');
        return false;
    }

    items[item_id].selected_lot_no = selectedLots;

    dispatch({
        type: ADD_ITEM,
        payload: items,
    });

    dispatch(setModal('lot_no_modal', false));
    return true;
};

export const getInternalNotesText = (notes) => {
    if (!notes) return '';

    // Case 1: already a plain string
    if (typeof notes === 'string') {
        return notes;
    }

    // Case 2: array (our normalized backend format)
    if (Array.isArray(notes)) {
        if (notes.length === 0) return '';

        const first = notes[0];

        // [{ message: 'for approval', ... }]
        if (first && typeof first.message === 'string') {
            return first.message;
        }

        // Old nested shape:
        // [{ message: [ { message: 'for approval', ... } ], ... }]
        if (first && Array.isArray(first.message) && first.message.length > 0) {
            const inner = first.message[0];
            if (typeof inner === 'string') return inner;
            if (inner && typeof inner.message === 'string') {
                return inner.message;
            }
        }

        // Fallback if items are strings
        if (typeof first === 'string') {
            return first;
        }

        return '';
    }

    // Case 3: single object { message: '...' }
    if (typeof notes === 'object' && typeof notes.message === 'string') {
        return notes.message;
    }

    return '';
};
